import React, { useContext } from 'react';
import { IdcardOutlined } from '@ant-design/icons';
import { c as LabelStringSet, L as Label, a as LabelTypography, b as LabelColors } from '@sendbird/uikit-react/index-4572759d.js';
import Icon, { IconTypes, IconColors } from '@sendbird/uikit-react/ui/Icon.js';
import IconButton from '@sendbird/uikit-react/ui/IconButton.js';
import ChannelAvatar from './customChannelAvatar';
import { a as LocalizationContext } from '@sendbird/uikit-react/LocalizationContext-a21fd99c.js';
import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext.js';
import { useChannelContext } from '@sendbird/uikit-react/Channel/context';
import IconArrowLeft from "../../assets/images/components/icon-arrow-left.svg";

import axios from '../../network/axios/$axios';

const SendNamecard = (props) => {
    const { channel, className, width, height = "32px" } = props;

    const onClick = () => { 
        
        console.log("Should Send NameCard", channel) 
        axios('sendNameCard', { pathObj: {chatId: channel.url}})
        .then((response) => {
          console.log('/navBarItem=', response);
        })
    
    }
    return (<div className={className} style={{ width, height, padding: "5px" }} onClick={onClick}> Send Namecard < IdcardOutlined /></div >)
}

const BackButton = (props) => {
    var channelStore = useChannelContext();
    
    const { channel,className,onBack, width="32px", height = "32px" } = props;
    const onBack2 = () => { 
        document.getElementsByClassName("sendbird-app__conversation-wrap")[0].style.display = "none";
        document.getElementsByClassName("sendbird-app__channellist-wrap")[0].style.display = "inline";
        channelStore.channelUrl = null;
        console.log(channelStore)
        document.getElementsByClassName("closeOutlined")[0].click()
        
    }
    return (
        <div className={className} onClick={onBack2}>
            <img width={width} heigth={height} src={IconArrowLeft} alt="Back button" />
        </div>
    )
}

var getChannelTitle = function (channel, currentUserId, stringSet) {
    var _a;

    var LABEL_STRING_SET = stringSet || LabelStringSet;

    if (!(channel === null || channel === void 0 ? void 0 : channel.name) && !(channel === null || channel === void 0 ? void 0 : channel.members)) {
        return LABEL_STRING_SET.NO_TITLE;
    }

    if ((channel === null || channel === void 0 ? void 0 : channel.name) && channel.name !== 'Group Channel') {
        return channel.name;
    }

    if (((_a = channel === null || channel === void 0 ? void 0 : channel.members) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        return LABEL_STRING_SET.NO_MEMBERS;
    }

    return channel === null || channel === void 0 ? void 0 : channel.members.filter(function (_a) {
        var userId = _a.userId;
        return userId !== currentUserId;
    }).map(function (_a) {
        var nickname = _a.nickname;
        return nickname || LABEL_STRING_SET.NO_NAME;
    }).join(', ');
};

var ChannelHeader = function (props) {

    var _a, _b, _c;
    var globalStore = useSendbirdStateContext();
    var userId = (_a = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _a === void 0 ? void 0 : _a.userId;
    var theme = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _b === void 0 ? void 0 : _b.theme;
    var channelStore = useChannelContext();
    var currentGroupChannel = channelStore.currentGroupChannel,
        showSearchIcon = channelStore.showSearchIcon,
        onSearchClick = channelStore.onSearchClick,
        onChatHeaderActionClick = channelStore.onChatHeaderActionClick;
    var subTitle = (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members) && ((_c = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.members) === null || _c === void 0 ? void 0 : _c.length) !== 2;
    var isMuted = (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.myMutedState) === "muted";
    var stringSet = useContext(LocalizationContext).stringSet;

    return /*#__PURE__*/React.createElement("div", {
        className: "sendbird-chat-header"
    }, /*#__PURE__*/React.createElement("div", {
        className: "sendbird-chat-header__left"
    },React.createElement(BackButton, {
        className: "sendbird-chat-header__back__button",
        channel: currentGroupChannel,
        onBack : props.onBack
        
    }),
    //  /*#__PURE__*/React.createElement(ChannelAvatar, {
    //     theme: theme,
    //     channel: currentGroupChannel,
    //     userId: userId,
    //     height: 32,
    //     width: 32
    // }),
     /*#__PURE__*/React.createElement(Label, {
        className: "sendbird-chat-header__left__title",
        type: LabelTypography.H_2,
        color: LabelColors.ONBACKGROUND_1
    }, getChannelTitle(currentGroupChannel, userId, stringSet)), /*#__PURE__*/React.createElement(Label, {
        className: "sendbird-chat-header__left__subtitle",
        type: LabelTypography.BODY_1,
        color: LabelColors.ONBACKGROUND_2
    },
        React.createElement(SendNamecard, {
            className: "sendbird-chat-header__right__info",
            channel: currentGroupChannel
        })
    )));
};

export { ChannelHeader as default };
  //# sourceMappingURL=ChannelHeader.js.map